import { Loan } from '../types/Loan'

// 0: UNISSUED
// 1 NEW: is set by default when loan is configured
// 2 APPROVED: is set when loan is fulfilled by the Investor
// 3 PAIDPART: is set after loan is repaid partially
// 4 CLOSED: is repaid in full
// 5 PAIDLATE: is set when repaid after maturity date + grace period
// 6 DEFAULT: is set when loan is liquidated
// 7: LATE: is set for loans which are late, but not paid yet

export const isLoanActive = (loan: Loan) =>
  loan.status !== 4 && loan.status !== 6
